import React from "react";

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

const IconHistory: React.FC<Props> = ({
  size = 32,
  color = "#3E3851",
  className = "fill-neutral-60",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M9.98276 17.0827C8.17832 17.0827 6.60568 16.4887 5.26484 15.3006C3.92401 14.1125 3.15214 12.6232 2.94922 10.8327H4.22484C4.43526 12.2718 5.08297 13.465 6.16797 14.4121C7.25283 15.3591 8.52443 15.8327 9.98276 15.8327C11.6078 15.8327 12.9862 15.2667 14.1182 14.1348C15.2501 13.0028 15.8161 11.6243 15.8161 9.99935C15.8161 8.37435 15.2501 6.99588 14.1182 5.86393C12.9862 4.73199 11.6078 4.16602 9.98276 4.16602C9.07248 4.16602 8.21943 4.36824 7.42359 4.77268C6.62762 5.17699 5.94221 5.73331 5.36734 6.44164H7.54693V7.69164H3.31609V3.46081H4.56609V5.43518C5.24234 4.63713 6.05221 4.01775 6.99568 3.57706C7.93901 3.13636 8.93471 2.91602 9.98276 2.91602C10.9657 2.91602 11.8866 3.10192 12.7457 3.47372C13.6046 3.84553 14.3535 4.35088 14.9923 4.98977C15.6312 5.62865 16.1366 6.37761 16.5084 7.23664C16.8802 8.09553 17.0661 9.01643 17.0661 9.99935C17.0661 10.9823 16.8802 11.9032 16.5084 12.7621C16.1366 13.6211 15.6312 14.37 14.9923 15.0089C14.3535 15.6478 13.6046 16.1532 12.7457 16.525C11.8866 16.8968 10.9657 17.0827 9.98276 17.0827ZM12.4844 13.3552L9.38193 10.2525V5.83268H10.6317V9.74622L13.3626 12.4768L12.4844 13.3552Z"
        fill={color}
      />
    </svg>
  );
};

export default IconHistory;
